import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { listConversations } from "@/lib/api";
import { HistoryItem } from "@/components/HistoryItem";

export const HistoryDrawer = ({ open, onOpenChange, profile }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { if (open) listConversations(profile?.id || "guest").then(setItems); }, [open, profile]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="pp-drawer" data-testid="history-drawer-container">
        <SheetHeader>
          <SheetTitle className="pp-h2">{profile ? `${profile.name}'s kind requests` : "Polite history"}</SheetTitle>
          <SheetDescription>Every request that ended with a thank you.</SheetDescription>
        </SheetHeader>
        <div className="mt-6 space-y-4 overflow-y-auto" style={{ maxHeight: "72vh" }}>
          {items.length === 0 && <p className="pp-sub" data-testid="history-empty">No completed directives yet.</p>}
          {items.map((c) => <HistoryItem key={c.id} c={c} />)}
        </div>
        <Link to="/family" className="pp-ghost mt-4" data-testid="drawer-family-link">Parents: open family area</Link>
      </SheetContent>
    </Sheet>
  );
};
